import { polyfill } from 'smoothscroll-polyfill';

// When the user scrolls down 20px from the top of the document, show the button
export function backToTop() {
    polyfill();
    if (document.getElementById("backToTop") === null || document.getElementById("backToTop") === undefined)
        return;

    //smoothscroll.polyfill();
    window.addEventListener("scroll", function () {
        window.requestAnimationFrame(scrollFunction);
    });
    document.getElementById("backToTop").onclick = function () { topFunction() };
}

function scrollFunction() {
    var footerLinksHeight = document.getElementById('footer-links').getBoundingClientRect().height;
    var footerLinksRect = document.getElementById('footer-links').getBoundingClientRect() as any;
    var backToTop = document.getElementById("backToTop");
    var windowHeight = window.innerHeight || document.documentElement.clientHeight;
    var bottomOffset = 20;
    var iconWidth = 40;
    var containerPadding = 48;
    if (window.innerWidth > 960) {
        containerPadding = 32
    } else if (window.innerWidth < 600) {
        containerPadding = 16;
    }

    if (footerLinksRect && footerLinksRect.x) {
        backToTop.style.left = `${footerLinksRect.x + footerLinksRect.width - iconWidth - containerPadding}px`;
    } else {
        backToTop.style.left = `${footerLinksRect.left + footerLinksRect.width - iconWidth - containerPadding}px`;
    }
    

    if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
        //backToTop.className = " " + fadeInClass;
        backToTop.classList.add('active');
    } else {
        //backToTop.className = " " + fadeOutClass;
        backToTop.classList.remove('active')
    }

    // If scrolled to the point where the arrow would start to run into the footer
    if (window.pageYOffset + windowHeight + footerLinksHeight > document.body.scrollHeight) {
        backToTop.style.bottom = (windowHeight - document.getElementById('footer-links').getBoundingClientRect().top) + bottomOffset + "px";
    } else {
        backToTop.style.bottom = bottomOffset + "px";
    }
}

// When the user clicks on the button, scroll to the top of the document
function topFunction() {
    window.scroll({ top: 0, left: 0, behavior: 'smooth' });
}